/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState, useEffect} from 'react';
import DismantlerLayout from "../../layouts/DismantlerLayout";
import axios from "axios";
import {useOutletContext, useParams} from "react-router-dom";
import Loader from "../../elements/loader";
import {getDismantler} from "../../Hooks/DesmantlerData";
import useAxiosJTW from "../../Hooks/useAxiosJTW";

const DismantlerCompany = () => {

    let params = useParams();
    const [merchant, setMerchant] = useState('');
    const [outletData, setOutletData] = useOutletContext();
    const [isLoading, setLoading] = useState(true);

    const axiosJWT = useAxiosJTW();

    const getmerchantbymerchantid = (signal) => {
        axiosJWT.post('api/getmerchantbymerchantid', { merchantid: decodeURIComponent(params.merchantid) }, {signal}).then( (response) => {
            if(response.status === 200){
                setMerchant(response.data.merchant_info || {});

                const dismantler = getDismantler(response.data.merchant_info, response.data.schedule);
                setOutletData(dismantler);

                setLoading(false);
            }
        } ).catch((error) => {
            console.log(error);
        });

    }

    useEffect(() => {
        const controller = new AbortController();
        const signal= controller.signal;

        getmerchantbymerchantid(signal);

        return () => {controller.abort();}
    }, [params]);

    return (
        // <DismantlerLayout>
            <div className='page-body'>
                <div className='dismantler--container'>
                    <h2 className='dismantler__title'>Company Profile </h2>
                    <div>

                        {isLoading ? (
                            <div style={{ paddingTop: '30px', textAlign : 'center', margin: '0 auto' }}><Loader/></div>
                        ) : (
                            <>{merchant.description}</>
                        )}

                    </div>

                    {/*<p className='dismantler__text'>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, co*/}
                    {/*    nsetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.*/}
                    {/*    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, con*/}
                    {/*</p>*/}

                    {/*<h3 className='dismantler__sub-title'>Consetetur sadipscing elitr, sed diam </h3>*/}
                    {/*<p className='dismantler__text'>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, co*/}
                    {/*    nsetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.*/}
                    {/*    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, con*/}
                    {/*</p>*/}

                    {/*<h3 className='dismantler__sub-title'>Services</h3>*/}
                    {/*<p className='dismantler__text'>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, co*/}
                    {/*    nsetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.*/}
                    {/*    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, con*/}
                    {/*</p>*/}

                    {/*<p className='dismantler__text'>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, co*/}
                    {/*    nsetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.*/}
                    {/*    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, con*/}
                    {/*</p>*/}
                </div>
            </div>
        // </DismantlerLayout>
    );
};

export default DismantlerCompany;
